module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/pro-audio-d9b3a9b151c73ca72535a1a9de9cb308.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/pro-audio.png
// module id = +4Ev
// module chunks = 9 12